<template>
  <Modal v-bind="$attrs" v-on="$listeners">
    <SfHeading :level="3" :title="title" class="sf-heading--left" />
    <SfDivider />
    <form @submit.prevent="submitFilter" class="row">
      <div class="col-xs-12">
        <div class="page-content" v-html="body" />
      </div>
    </form>
  </Modal>
</template>

<script>
import { Modal } from '@/modules/core';
import { SfHeading, SfDivider } from '@storefront-ui/vue';

export default {
  name: 'AttentionModal',
  components: {
    Modal,
    SfHeading,
    SfDivider,
  },
  data() {
    return {};
  },
  props: {
    title: String,
    body: String,
  },
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import '~@storefront-ui/shared/styles/_helpers';
@import 'src/scss/_breakpoint';

.sf-heading,
.sf-divider {
  margin-bottom: var(--spacer-sm);
}

.sf-modal {
  --modal-width: auto;
}
</style>
